import { render, staticRenderFns } from "./VideoCategory.vue?vue&type=template&id=d94fb530"
import script from "./VideoCategory.vue?vue&type=script&lang=js"
export * from "./VideoCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports